import { useEffect } from 'react';
import { useFormikContext } from 'formik';

import { getNormalizedBillingDefaults } from '../helpers';

// Enforces the billing normalization rules for whichever payment method is active. Each payment-method
// sub-component (BankAccounts/CreditCards/Mortgage/Direct/BillToOther) calls this with its own method so
// the rules live in exactly one place — getNormalizedBillingDefaults. The Payment tab seeds its Formik
// initialValues from the same function, so the form no longer opens pre-dirtied (#32985); this on-mount
// pass then finds nothing to change and the "Save changes" footer only appears on real edits.
export const useNormalizePaymentMethod = (paymentMethod) => {
  const { values, setFieldValue } = useFormikContext();
  const { paymentType, paymentMode } = values;

  useEffect(() => {
    const normalized = getNormalizedBillingDefaults({ paymentMethod, paymentType, paymentMode });
    if (normalized.paymentType !== paymentType) {
      setFieldValue('paymentType', normalized.paymentType);
    }
    if (normalized.paymentMode !== paymentMode) {
      setFieldValue('paymentMode', normalized.paymentMode);
    }
  }, [paymentMethod, paymentType, paymentMode, setFieldValue]);
};
